import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=2d0bc52a&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=2d0bc52a&prod&lang=scss&scoped=true"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&id=2d0bc52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0bc52a",
  null
  
)

export default component.exports